import { Markup } from '@/components/Markup';
import { Prose } from './Prose';

export const StandaloneProse: typeof Markup = (props) => <Prose {...props} />;
